import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { Router, RouterEvent } from "@angular/router";
import {
    CclNavbarSecondaryService,
    CclSideNavItem,
    CclMessageService,
    CclNavbarFooterService
} from "certain-common-library";
import { SharedService } from "../../../modules/shared/services/shared.service";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { SessionWidgetService } from "../../../modules/shared/services/session-widget.service";

@Component({
    selector: "app-item-context",
    templateUrl: "./catalog-context.view.html",
    styleUrls: []
})
export class CatalogContextView implements OnInit, AfterViewInit, OnDestroy {
    navLinks: CclSideNavItem[];
    private subscription: Subscription;
    sessionWidgets: any = [];

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private router: Router,
        private messageService: CclMessageService,
        private navbarFooterService: CclNavbarFooterService,
        private sessionWidgetService: SessionWidgetService
    ) {
        this.navSecondaryService.includeSave = false;
        this.sharedService.enableSessionWidgets = (!this.isUndefined(this.sharedService.event) && !this.isUndefined(this.sharedService.event?.prodIdList) && this.sharedService.event?.prodIdList?.split(",").includes("111"));
        if(this.sharedService.enableSessionWidgets) {
            this.fetchAndLoadWIdgetsData();
        }
        this.navLinks = [
            {
                label: "Define Layout",
                icon: "fa-sliders",
                route: "setting"
            },
            {
                label: "Design Elements",
                icon: "fa-list-alt",
                route: "layout"
            },
            {
                label: "Data",
                icon: "fa-database",
                route: "data"
            },
            {
                label: "Additional Settings",
                icon: "fa-briefcase",
                route: "add-setting"
            }
        ];

        this.subscription = this.messageService.getMessage().subscribe((message) => this.changeContext(message));
        this.router.events.pipe(filter((e) => e instanceof RouterEvent)).subscribe((e) => {
            let catalogLayoutConfig = JSON.parse(this.sharedService.setup.layoutConfig);
            if (
                e["urlAfterRedirects"] == "/admin/" + this.sharedService.catalogUUID + "/catalog/data/highlighted" &&
                catalogLayoutConfig.listType != "magazine"
            ) {
                if (catalogLayoutConfig.listType == "promoted") {
                    this.sharedService.catalogNavigateHelper("admin", "catalog/data/promoted");
                } else {
                    this.sharedService.catalogNavigateHelper("admin", "catalog/data/general");
                }
            } else if (
                e["urlAfterRedirects"] == "/admin/" + this.sharedService.catalogUUID + "/catalog/data/promoted" &&
                catalogLayoutConfig.listType != "magazine" &&
                catalogLayoutConfig.listType != "promoted"
            ) {
                this.sharedService.catalogNavigateHelper("admin", "catalog/data/general");
            }

            if (this.navbarFooterService.navbar != null) {
                if (e["url"] == "/admin/" + this.sharedService.catalogUUID + "/catalog/add-setting/rules-validation-config") {
                    this.navbarFooterService.navbar.rightNavbarItems[2].label = "SAVE & PREVIEW";
                } else {
                    this.navbarFooterService.navbar.rightNavbarItems[2].label = "SAVE & NEXT";
                }
            }
        });
    }

    ngOnInit() {
        this.sharedService.enableSessionWidgets = (!this.isUndefined(this.sharedService.event) && !this.isUndefined(this.sharedService.event?.prodIdList) && this.sharedService.event?.prodIdList?.split(",").includes("111"));
        if(this.sharedService.enableSessionWidgets) {
            this.fetchAndLoadWIdgetsData();
        }
    }

    ngAfterViewInit(): void {
        this.navSecondaryService.contextLabel =
            this.sharedService.account.name +
            " - " +
            this.sharedService.event.name +
            " - " +
            this.sharedService.setup.catalogName;
        document.title = "Session Catalog Admin - " + this.sharedService.setup.catalogName;
    }

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    changeContext(message) {
        if (message.text == "update-context") {
            this.navSecondaryService.contextLabel =
                message.data.account.name + " - " + message.data.event.name + " - " + message.data.catalog.catalogName;
        } else if (message.text == "use-default") {
            this.openPopup(message.data.popupName);
        }
    }

    openPopup(item) {
        this.sharedService.currentPopup = {
            title: null,
            navLinks: null,
            saveMessage: null,
            showFooter: false
        };
        let url = "popup/default-setup";
        this.sharedService.navigateToOutlet("popup", url);
    }

    isUndefined(object) {
        if (object == undefined || object == null) {
            return true;
        } else {
            return false;
        }
    }

    hasCatalogNavLink(route: string): boolean {
        return this.navLinks.some(item => item.route === route);
    }

    updateCatalogNavLinksAfterApi() {
        this.navLinks = (this.sharedService.enableSessionWidgets && !this.hasCatalogNavLink('recommendations-widget')) ? 
                        [...this.navLinks.slice(0, 2), {label: "Event Advisor", icon: "fa-sign-in", route: "recommendations-widget"}, ...this.navLinks.slice(2)] : 
                        this.navLinks;
    }

    async fetchAndLoadWIdgetsData() {
        await this.sessionWidgetService.getRecommendationWidgetsByUUID(this.sharedService.eventUUID).subscribe({
            next: (response) => {
                this.sessionWidgets = response.body;
                this.sharedService.enableSessionWidgets = (this.sharedService.enableSessionWidgets && this.sessionWidgets.length > 0);
                this.updateCatalogNavLinksAfterApi();
              },
              error: (err) => {
                this.sessionWidgets = [];
                this.sharedService.enableSessionWidgets = false;
                this.updateCatalogNavLinksAfterApi();
              } 
        });
      }
}
